import { PeopleTypes } from "enums/peopleTypes";
import { useFetchPublishedFixtureRoster } from "hooks/useFixtureRosterApi";
import { useFetchPublishedFixtureStaff } from "hooks/useFixtureStaffApi";
import { useFixtureRosterColumns } from "./useFixtureRosterColumns";
import { useFixtureStaffColumns } from "./useFixtureStaffColumns";

type Props = {
  type: PeopleTypes;
  entityId: string;
  seasonId: string;
  fixtureId: string;
  enabled: boolean;
};

export const usePreviewPeople = ({ type, entityId, seasonId, fixtureId, enabled }: Props) => {
  const { data: rosterResponse, isLoading: isRosterLoading } = useFetchPublishedFixtureRoster({
    entityId,
    seasonId,
    fixtureId,
    enabled: type === PeopleTypes.Roster && enabled,
  });

  const { data: staffResponse, isLoading: isStaffLoading } = useFetchPublishedFixtureStaff({
    entityId,
    seasonId,
    fixtureId,
    enabled: type === PeopleTypes.Staff && enabled,
  });

  const rosterColumns = useFixtureRosterColumns({
    viewOnly: true,
    editMode: false,
  });
  const staffColumns = useFixtureStaffColumns({
    viewOnly: true,
    editMode: false,
  });

  return {
    isLoading: isRosterLoading || isStaffLoading,
    records:
      type === PeopleTypes.Roster
        ? rosterResponse?.data?.filter((x) => x.isActive === true) || []
        : type === PeopleTypes.Staff
          ? staffResponse?.data?.filter((x) => x.isActive === true) || []
          : [],
    columns: type === PeopleTypes.Roster ? rosterColumns : type === PeopleTypes.Staff ? staffColumns : [],
  };
};
